<section class="section white-100" *ngIf="_companiesData">
  <div class="section-container mar-b-a">
    <div class="testimonial">
      <ngx-slick-carousel
        class="carousel"
        #slickModal
        [config]="slideConfig"
        *ngIf="_companiesData"
      >
        @for (logos of _companiesData; track logos) {
          <div ngxSlickItem class="slide">
            <img src="{{ logos }}" alt="" loading="lazy" />
          </div>
        }
      </ngx-slick-carousel>
    </div>
    <app-trust-pilot
      [bgWhite]="false"
      [paddTop]="true"
    ></app-trust-pilot>
  </div>
</section>
